import DEFAULT_REACTIONS from 'constants/reactions';
import { createSelector } from 'reselect';
import authCompany from './authCompany';

const companyReactions = createSelector(authCompany, company => {
  if (Array.isArray(company?.reactions) && company.reactions.length > 0) {
    return company.reactions;
  }
  return DEFAULT_REACTIONS;
});

export default companyReactions;
